import axios from 'axios'
import React from 'react'
import { backMfa } from '../urlApi'
import Swal from 'sweetalert2'
import { validarOtp } from '../store/actions/login.actions'
import { useDispatch, useSelector } from 'react-redux'

export const UseVerifyOtp = () => {

  const dispatch = useDispatch()

  const data = useSelector(state => state.login.data)




  const validateOtp = async (token)=> {
    try {
      const conid = localStorage.getItem('conid')


      const response = await axios.post(`${backMfa}auth/personas/otp/validate`, { conid, token })



      if(response.data.otp_valid === true ){
            
         dispatch(validarOtp())

         localStorage.setItem('token', data.strCon)

        //  console.log('???')

      }
     
 } catch (error) {
   
     
     Swal.fire({
         title: 'Código incorrecto',
         text: 'Intentalo otra vez',
         confirmButtonColor:'#2ec1db',
         
       })
 }


 
  }


  
const validateOtpWebsal = async (token = '')=> {
    
  const codigo =  localStorage.getItem('codigo')
  const sid =  localStorage.getItem('sid')

  
      try {


        const response = await axios.post(`${backMfa}/auth/otp/validate`, { codigo, sid,token })

        console.log(response.data)

        if(response.data.otp_valid === true ){

          localStorage.setItem('vencimiento', `${Date.now()}`)
              
          dispatch(validarOtp())

          

          //  console.log('???')

        }
      
    } catch (error) {
    
      Swal.fire({
        title: 'Código incorrecto',

        confirmButtonColor:'#2ec1db',
      })
    
    }
}


  return {
     verifyOtp,validateOtp,validateOtpWebsal
  }
}



export const verifyOtp = async (x) => {

  try {

    const response = await axios.post(`${backMfa}api/helpers/verificar-enabled-personas`, {conid:x})

    return response.data


    
  } catch (error) {

    console.log(error)
   
  }

}


export const verifyOtpWebsal = async (sid,codigo) => {

  try {

    const response = await axios.post(`${backMfa}/api/helpers/verificar-enabled-websal`, {sid,codigo})


    return response.data


    
  } catch (error) {
// console.log('acea')
    console.log(error)
   
  }

}


export const verifyOtpObligatorioWebsal = async (sid) => {

  try {

    const response = await axios.post(`${backMfa}/api/helpers/verificar-mfa-obligatorio-websal`, {sid})

    return response.data


    
  } catch (error) {
// console.log('acea')
    console.log(error)
   
  }

}